import * as pinia from 'pinia';

const useTilesLayoutStore = pinia.defineStore('StreamsLayoutStore', {
  state: () => ({
    focusedStreamId: false,
  }),

  getters: {
    focusMode: (state) => !!state.focusedStreamId,
  },

  actions: {
    addItems(count, item) {
      for (let i = 0; i < parseInt(count, 10); i++) this.items.push({ ...item });
    },
    disableFocusMode() {
      this.focusedStreamId = null;
    },
    focusStream(_streamId) {
      this.focusedStreamId = _streamId;
    },
  },
});
export default useTilesLayoutStore;
